import { UnStyledUl } from 'src/ui/list';
import styled from 'styled-components';
import { media, layout } from '@prisjakt/ui-base';

export const StyledUl = styled(UnStyledUl)`
  > li {
    /* stylelint-disable property-no-vendor-prefix */
    -webkit-column-break-inside: avoid;
    page-break-inside: avoid;
    break-inside: avoid;
  }
  ${media.mediumUp`
    column-gap: ${layout.measurements.spacing200};
    break-inside: avoid-column;
    columns: 2;
    `}
`;
